import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import NodeGraph from "./NodeGraph";
import { useAuth } from "@/contexts/AuthContext";
import { dashboardPathForUser } from "@/lib/roleRoutes";

export default function Hero() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <section className="relative bg-gradient-to-br from-[#0B0F1E] via-[#141C38] to-[#0B0F1E] overflow-hidden pt-16 pb-24 sm:pt-24 sm:pb-32">
      <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-indigo-600/25 blur-[100px]" />
      <div className="absolute -bottom-32 -right-20 h-96 w-96 rounded-full bg-cyan-500/20 blur-[100px]" />
      <div className="absolute inset-0 opacity-[0.15] [background-image:radial-gradient(circle_at_1px_1px,#4338CA_1px,transparent_0)] [background-size:32px_32px]" />
      <div className="max-w-7xl mx-auto px-6 relative grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-indigo-500/30 bg-indigo-500/10 px-4 py-1.5 mb-8" data-testid="hero-eyebrow-badge">
            <Sparkles className="h-3.5 w-3.5 text-indigo-400" />
            <span className="text-xs uppercase tracking-[0.2em] font-medium text-indigo-300">Research-Grounded Career Discovery</span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white mb-6">
            Discover the Career Paths That Fit the Way You Think, Work and Grow.
          </h1>
          <p className="text-base sm:text-lg text-slate-400 leading-relaxed mb-10 max-w-lg">
            CareerStudy360 goes beyond marks and conventional career choices. It explores your interests, personality,
            reasoning abilities, professional strengths, work preferences, values and decision patterns to build a
            broader picture of where you could thrive — across science, engineering, civil services, healthcare,
            entrepreneurship, finance, technology, defence, design, social impact and many more fields.
          </p>
          <div className="flex flex-wrap gap-4">
            <Button data-testid="hero-start-journey-button" onClick={() => navigate(user ? dashboardPathForUser(user) : "/login")} className="h-12 rounded-full px-8 bg-indigo-600 hover:bg-indigo-500 text-base">
              {user ? "Go to Dashboard" : "Start Your Career Assessment"} <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
            <Button data-testid="hero-how-it-works-button" variant="outline" asChild className="h-12 rounded-full px-8 border-slate-700 text-slate-200 hover:bg-slate-800 text-base">
              <a href="#how-it-works">Explore How It Works</a>
            </Button>
          </div>
        </div>
        <NodeGraph />
      </div>
    </section>
  );
}
